/**
 * Permission code constants — values match the `code` field returned by
 * user-manager/roles/{role_id}.
 */
export const PERMISSIONS = {
    SUPER_ADMIN: "super_admin",
    // Requests
    REQUEST_VIEW: "view_request",
    REQUEST_CREATE: "create_request",
    REQUEST_REVIEW: "review_request",
    REQUEST_EDIT: "requests.edit",
    REQUEST_SUBMIT: "requests.submit",
    REQUEST_DELETE: "requests.delete",
    REQUEST_VOTE: "requests.vote",
    // Request type configuration
    REQUEST_TYPE_CONFIG_VIEW: "request_type_config.view",
    REQUEST_TYPE_CONFIG_CREATE: "request_type_config.create",
    REQUEST_TYPE_CONFIG_EDIT: "request_type_config.edit",
    REQUEST_TYPE_CONFIG_PUBLISH: "request_type_config.publish",
    REQUEST_TYPE_CONFIG_DELETE: "request_type_config.delete",
    REQUEST_TYPE_CONFIG_CLONE: "request_type_config.clone",
    // AI Playground
    PLAYGROUND_ACCESS: "ai_playground",
    AI_REVIEW: "ai_review",
    // Configuration (Admin settings pages)
    CONFIG_VIEW: "view_config",
    CONFIG_EDIT: "edit_config",
    // Master data
    MASTER_VIEW: "view_master",
    MASTER_EDIT: "edit_master",
    // Reports
    REPORTS_RUN: "run_reports",
};
/** Grants access to the Admin sidebar section (any one is sufficient). */
export const ADMIN_PERMISSIONS = [
    PERMISSIONS.CONFIG_EDIT,
    PERMISSIONS.CONFIG_VIEW,
    PERMISSIONS.REQUEST_TYPE_CONFIG_VIEW,
];
